import React from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

import SideContentBlock from "../../../shared/sideContentBlock";
import ReportHistoryContentTitle from "../reports/reportHistoryContentTitle";
import SideContentInner from "../../../shared/sideContentInner";
import ReportsHistoryControls from "./../reports/reportsHistoryControls";
import ListHistoryReports from "./../reports/listHistoryReports";

import styles from "./historyReports.module.scss";

const HistoryReports = () => {
  return (
    <Scrollbars style={{ height: "100%" }} autoHide={true}>
      <div className={styles.reportsHistory}>
        <div className={styles.reportsHistory_container}>
          <SideContentBlock>
            <ReportHistoryContentTitle />
            <div className={styles.reportsHistoryWrapper}>
              <SideContentInner>
                <div className={styles.container_reportsHistory}>
                  <div className={styles.container_reportsHistoryControls}>
                    <ReportsHistoryControls />
                  </div>
                  <div className={styles.container_reportsHistoryList}>
                    <ListHistoryReports />
                  </div>
                </div>
              </SideContentInner>
            </div>
          </SideContentBlock>
        </div>
      </div>
    </Scrollbars>
  );
};

export default React.memo(HistoryReports);
